import type { ActivityDetail } from '@painpal/contracts';
import { summaryTiles, type Tile } from './detailModel';
import { detailLayout, hrTiles, runTiles } from './runDetailModel';
import styles from './detail.module.css';

function tilesFor(activity: ActivityDetail, gps: boolean | null): Tile[] {
  const layout = detailLayout(activity);
  if (layout === 'run') return runTiles(activity);
  return layout === 'hr' ? hrTiles(activity, gps) : summaryTiles(activity);
}

export function SummaryTiles({ activity, gps }: { activity: ActivityDetail; gps: boolean | null }) {
  return (
    <dl className={styles.tiles} data-layout={detailLayout(activity)}>
      {tilesFor(activity, gps).map((tile) => (
        <div key={tile.key} className={styles.tile} data-tile={tile.key}>
          <dt className={styles.tileLabel}>{tile.label}</dt>
          <dd className={styles.tileValue} data-muted={tile.muted === true || undefined}>{tile.value}</dd>
          <dd className={styles.tileNote}>{tile.note}</dd>
        </div>
      ))}
    </dl>
  );
}
